import * as React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import TopBarMenu from './TopBarMenu';

const TopBar = ({ menuVisible }) => {
  const data = useStaticQuery(graphql`
    query topNavMenu {
      wpMenu(slug: { eq: "top-nav" }) {
        name
        count
        databaseId
        menuItems {
          nodes {
            cssClasses
            url
            target
            path
            label
            order
            menuAcf {
              menuIcon {
                sourceUrl
              }
            }
          }
        }
      }
    }
  `);

  return (
    <TopBarMenu
      menuItems={data.wpMenu.menuItems.nodes}
      menuVisible={menuVisible}
    />
  );
};

export default TopBar;
